module.exports = __webpack_public_path__ + "img/podologue-es.5caa0ef8.jpg";